export const getSnippetPreviewMessage = (text: string, fieldBindings: { key: string; value: string | null }[] = []) => {
    if (!fieldBindings || fieldBindings.length === 0) {
        return text;
    }

    const bindingsMap = new Map(fieldBindings.map((b) => [b.key, b.value]));

    return text
        .replace(/\{\{\s*field=>(\w+)\s*\}\}/g, (match, key) =>
            bindingsMap.has(key) ? bindingsMap.get(key) ?? '' : match
        )
        .trim();
};
